function productRecommendations (url, el, productLimit) {
  fetch(url)
    .then(response => response.text())
    .then(text => {
      const recommendations = $(text).find('product-recommendations');
      if (recommendations) {
        $(el).append(recommendations.html());
        this.innerHTML = recommendations.innerHTML;
      }

      if (productLimit > 4) {
        var swiperPerView = $('.listRelatedProductsSwiper').attr('data-swiper-slides');
        var swiperRelated = new Swiper(".listRelatedProductsSwiper", {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: false,
          centeredSlides: true,
          pagination: {
            el: ".js-related-products-swiper-pagination",
            type: "progressbar",
          },
          navigation: {
            nextEl: ".js-related-products-swiper-button-next",
            prevEl: ".js-related-products-swiper-button-prev"
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
              centeredSlides: false,
            },
            1024: {
              slidesPerView: swiperPerView,
              centeredSlides: false,
            },
          },
        });
      }

      $('[js-loader-section-related-products]').addClass('d-none');
    }).catch(e => {
      console.error(e);
    });
}

$('product-recommendations').each(function(index, el) {
  var URL = $(el).attr('data-url');
  var productLimit = $(el).attr('data-limit');
  productRecommendations(URL, el, productLimit);
});